import { ga } from 'js/analytics/adapters'
export const trackLogOut = () => {
  ga.track('log_out')
}
